import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_User = _resolveComponent("User")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_SystemRolesPermissions = _resolveComponent("SystemRolesPermissions")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: _ctx.name }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tabs, { "tab-position": "left" }, {
        default: _withCtx(() => [
          (_ctx.canView('users'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "1",
                tab: "Users"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_User)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canView('roles'))
            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: "2",
                tab: "System Roles and Permissions"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SystemRolesPermissions)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}